import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Loading, Modal, SystemText } from '@salesperformanceint/e4shared';
import BlobImage from 'components/blobImage';
import { apiGet } from 'services';
import { e4Format, e4Formats } from 'helpers/dates';

export const CompetencyGridBlogs = ({ show, close, competency, item }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    const st = (path, ...rest) => SystemText(`Dashboard/Widgets/CompetencyGrid/${path}`, ...rest);

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        show &&
            competency &&
            apiGet(`dashboard/competency-grid/blogs/${competency.id}/${item.id}`, guid, response => gotResponse(response));
    }, [guid, show, competency, item]);

    const closeMe = () => {
        close?.();
        setLoading(true);
        setData([]);
    };

    if (!competency) return null;
    return (
        <Modal show={show} close={closeMe} title={st('Blogs/Popup/Title', competency.full_Name)}>
            {loading ? (
                <Loading />
            ) : (
                <div data-testid="blogs">
                    {data.length === 0 && <p>{st('Blogs/Popup/NoResults')}</p>}
                    {data.map((blog, i) => {
                        return (
                            <div key={blog.id}>
                                {i > 0 && <hr />}
                                <div className="flex flex-top">
                                    <div className="mr10" style={{ width: '100px' }}>
                                        <BlobImage folder="blog_Image" src={blog.blog_Image} />
                                    </div>
                                    <div>
                                        <h4>
                                            <Link to={`/blog/post/${blog.id}`}>{blog.title}</Link>
                                        </h4>
                                        <div className="text-sm">
                                            <Link to={`/blog/${blog.owner_Id}`}>{blog.owner_Full_Name}</Link> |{' '}
                                            {e4Format(blog.date, e4Formats.long)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </Modal>
    );
};

export default withRouter(CompetencyGridBlogs);
